"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "2xl:container mx-auto pb-4 print-margin" };
const _hoisted_2 = { class: "text-2xl print-text-sm pl-5 my-5 font-bold uppercase" };
const _hoisted_3 = { class: "filters justify-between lg:items-end print:hidden" };
const _hoisted_4 = { class: "flex flex-col md:flex-row gap-4" };
const _hoisted_5 = { class: "flex flex-col md:flex-row gap-4" };
const _hoisted_6 = { class: "font-bold cursor-pointer" };
const _hoisted_7 = { class: "cursor-pointer" };
const _hoisted_8 = { class: "cursor-pointer" };
const _hoisted_9 = { class: "text-center cursor-pointer" };
const _hoisted_10 = {
    key: 0,
    class: "marso-icon-check"
};
const _hoisted_11 = {
    key: 1,
    class: "marso-icon-close"
};
const _hoisted_12 = { class: "text-center cursor-pointer" };
const _hoisted_13 = { class: "text-center cursor-pointer" };
const _hoisted_14 = { class: "text-center cursor-pointer" };
const _hoisted_15 = { class: "text-center cursor-pointer" };
const _hoisted_16 = { class: "p-4 mb-5 flex bg-white border border-gray rounded shadow" };
const _hoisted_17 = { class: "w-1/2" };
const _hoisted_18 = { class: "font-bold mb-3 underline underline-offset-8" };
const _hoisted_19 = { class: "w-1/2 text-right" };
const _hoisted_20 = {
    key: 0,
    class: "font-bold mb-3 underline underline-offset-8"
};
const _hoisted_21 = {
    key: 1,
    class: "font-bold mb-3 underline underline-offset-8"
};
const _hoisted_22 = { class: "table-auto w-full border-2 border-gray" };
const _hoisted_23 = { class: "border-2 border-gray" };
const _hoisted_24 = { class: "p-2 text-left" };
const _hoisted_25 = { class: "p-2 text-left" };
const _hoisted_26 = { class: "p-2 text-left" };
const _hoisted_27 = { class: "p-2 text-center" };
const _hoisted_28 = { class: "p-2 text-center" };
const _hoisted_29 = { class: "p-2 text-center" };
const _hoisted_30 = { class: "p-2 text-center" };
const _hoisted_31 = { class: "p-2 text-right" };
const _hoisted_32 = { style: { "font-weight": "normal" } };
const _hoisted_33 = { class: "border-b-1 border-gray" };
const _hoisted_34 = { class: "p-2 text-left" };
const _hoisted_35 = { class: "p-2 text-left" };
const _hoisted_36 = { class: "p-2 text-left" };
const _hoisted_37 = { class: "p-2 text-center" };
const _hoisted_38 = { class: "p-2 text-center" };
const _hoisted_39 = { class: "p-2 text-center" };
const _hoisted_40 = { key: 0 };
const _hoisted_41 = { key: 1 };
const _hoisted_42 = { key: 2 };
const _hoisted_43 = { class: "p-2 text-center" };
const _hoisted_44 = { key: 0 };
const _hoisted_45 = { key: 1 };
const _hoisted_46 = { key: 2 };
const _hoisted_47 = { class: "p-2 text-right" };
const _hoisted_48 = { class: "flex mt-[60px]" };
const _hoisted_49 = { class: "w-1/3 flex" };
const _hoisted_50 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "w-1/3" }, null, -1);
const _hoisted_51 = { class: "w-1/3" };
const _hoisted_52 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "w-full border-b-1 border-black h-[25px]" }, null, -1);
const _hoisted_53 = { class: "w-full text-center" };
const _hoisted_54 = { class: "flex flex-col lg:flex-row mt-3 print:hidden" };
const _hoisted_55 = { class: "lg:grow text-left flex justify-start" };
const _hoisted_56 = { class: "lg:grow text-right flex justify-end" };
const vue_3 = require("vue");
const shop_1 = require("../../common/utils/shop");
const i18n_1 = require("../../common/i18n");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const ShopInput_vue_1 = __importDefault(require("../../components/Form/ShopInput.vue"));
const Modal_vue_1 = __importDefault(require("../../components/Modal.vue"));
const vue_router_1 = require("vue-router");
const securityStore_1 = require("../../stores/security/securityStore");
const toastStore_1 = require("../../stores/toast/toastStore");
const AxaptaCustomerProductReturnStatusEnum_1 = require("../../stores/axaptaCustomerProductReturn/AxaptaCustomerProductReturnStatusEnum");
const axaptaCustomerProductReturnStore_1 = require("../../stores/axaptaCustomerProductReturn/axaptaCustomerProductReturnStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'CustomerProductReturnList',
    setup(__props) {
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const axaptaCustomerProductReturnStore = (0, axaptaCustomerProductReturnStore_1.useAxaptaCustomerProductReturnStore)();
        const router = (0, vue_router_1.useRouter)();
        const successfulSubmissionModalIsOpen = (0, vue_3.ref)(false);
        const modalData = (0, vue_3.ref)([]);
        const defaultFilterStartDate = (0, vue_3.computed)(() => {
            let halfYearBeforeToday = new Date();
            halfYearBeforeToday.setMonth(halfYearBeforeToday.getMonth() - 6);
            return (0, shop_1.formatDate)(halfYearBeforeToday);
        });
        const defaultFilterEndDate = (0, vue_3.computed)(() => {
            return (0, shop_1.formatDate)(new Date());
        });
        const filter = (0, vue_3.ref)({
            startDate: defaultFilterStartDate.value,
            endDate: defaultFilterEndDate.value,
            status: AxaptaCustomerProductReturnStatusEnum_1.AxaptaCustomerProductReturnStatusEnum.ALL,
        });
        const listFields = (0, vue_3.ref)([
            {
                key: "axaptaId",
                label: (0, i18n_1.trans)("axapta_id", "Axapta ID", "customer_product_return_list"),
                value: "axaptaId",
            },
            {
                key: "createdDate",
                label: (0, i18n_1.trans)("created_date", "Created Date", "customer_product_return_list"),
                value: "createdDate",
            },
            {
                key: "siteName",
                label: (0, i18n_1.trans)("site_name", "Site", "customer_product_return_list"),
                value: "siteName",
            },
            {
                key: "name",
                label: (0, i18n_1.trans)("name", "Name", "customer_product_return_list"),
                value: "name",
            },
            {
                key: "requireDelivery",
                label: (0, i18n_1.trans)("require_delivery", "Require delivery", "customer_product_return_list"),
                value: "requireDelivery",
            },
            {
                key: "totalItems",
                label: (0, i18n_1.trans)("total_items", "Total items", "customer_product_return_list"),
                value: "totalItems",
            },
            {
                key: "inProgressItems",
                label: (0, i18n_1.trans)('in_progress_items', "In progress items", 'customer_product_return_list'),
                value: "inProgressItems"
            },
            {
                key: "acceptedItems",
                label: (0, i18n_1.trans)("accepted_items", "Accepted items", "customer_product_return_list"),
                value: "acceptedItems",
            },
            {
                key: "cancelledItems",
                label: (0, i18n_1.trans)('cancelled_items', "Cancelled items", 'customer_product_return_list'),
                value: "cancelledItems"
            },
        ]);
        const queryCustomerProductReturns = () => {
            if (filter.value.startDate === "") {
                filter.value.startDate = defaultFilterStartDate.value;
            }
            if (filter.value.endDate === "") {
                filter.value.endDate = defaultFilterEndDate.value;
            }
            axaptaCustomerProductReturnStore.getCustomerProductReturnList(router, filter.value, securityStore.authenticatedUser.customer.id)
                .catch((error) => { toastStore.addErrorToast(error.toString()); });
        };
        const openModal = (event, item) => {
            modalData.value = item.extra;
            successfulSubmissionModalIsOpen.value = true;
        };
        const printPage = () => {
            // Ezekre a sorokra a DEV-2797 task megoldásához volt szükség.
            // A nyomtatási nézetben duplázódtak az elemek, ez a két style tulajdonság megoldotta a problémát.
            // A tulajdonságokat nem kell levenni a html-ről a print után, mert a modalból kilépve az oldal újratöltődik.
            let html = document.querySelector('html');
            if (html) {
                html.style.height = "100%";
                html.style.overflow = "hidden";
            }
            let body = document.querySelector('body');
            if (body) {
                body.style.height = "100%";
                body.style.overflow = "hidden";
            }
            window.print();
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('customer_product_return_list', 'Customer product return List', 'customer_product_return_list')), 1),
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('start_date_placeholder', 'Start Date', 'customer_product_return_list'),
                            label: (0, vue_2.unref)(i18n_1.trans)('start_date_label', 'Start Date', 'customer_product_return_list'),
                            modelValue: filter.value.startDate,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((filter.value.startDate) = $event)),
                            type: "date",
                            required: "",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('end_date_placeholder', 'End Date', 'customer_product_return_list'),
                            label: (0, vue_2.unref)(i18n_1.trans)('end_date_label', 'End Date', 'customer_product_return_list'),
                            modelValue: filter.value.endDate,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((filter.value.endDate) = $event)),
                            type: "date",
                            required: "",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn btn-rounded btn-warning h-[48px]",
                            onClick: _cache[2] || (_cache[2] = ($event) => (printPage()))
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("print", "Print", "customer_product_return_list")), 1),
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn btn-rounded btn-primary h-[48px]",
                            onClick: queryCustomerProductReturns
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("submit_query", "Submit Query", "customer_product_return_list")), 1)
                    ])
                ]),
                (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                    fields: listFields.value,
                    "onUpdate:fields": _cache[3] || (_cache[3] = ($event) => ((listFields).value = $event)),
                    items: (0, vue_2.unref)(axaptaCustomerProductReturnStore).axaptaCustomerProductReturnList,
                    striped: "",
                    condensed: "",
                    panel: "",
                    "need-row-click-emit": true,
                    "onClick:tableRow": openModal
                }, {
                    "cell-axaptaId": (0, vue_2.withCtx)(({ item }) => [
                        (0, vue_2.createElementVNode)("span", _hoisted_6, (0, vue_2.toDisplayString)(item.axaptaId), 1)
                    ]),
                    "cell-createdDate": (0, vue_2.withCtx)(({ item }) => [
                        (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(item.date), 1)
                    ]),
                    "cell-siteName": (0, vue_2.withCtx)(({ item }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)(item.siteName), 1)
                    ]),
                    "cell-name": (0, vue_2.withCtx)(({ item }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_8, (0, vue_2.toDisplayString)(item.name), 1)
                    ]),
                    "cell-requireDelivery": (0, vue_2.withCtx)(({ item }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_9, [
                            (item.requireDelivery == 1)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_10))
                                : (0, vue_2.createCommentVNode)("", true),
                            (item.requireDelivery == 0)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_11))
                                : (0, vue_2.createCommentVNode)("", true)
                        ])
                    ]),
                    "cell-totalItems": (0, vue_2.withCtx)(({ item }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_12, (0, vue_2.toDisplayString)(item.totalItems), 1)
                    ]),
                    "cell-inProgressItems": (0, vue_2.withCtx)(({ item }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_13, (0, vue_2.toDisplayString)(item.inProgressItems), 1)
                    ]),
                    "cell-acceptedItems": (0, vue_2.withCtx)(({ item }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_14, (0, vue_2.toDisplayString)(item.acceptedItems), 1)
                    ]),
                    "cell-cancelledItems": (0, vue_2.withCtx)(({ item }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_15, (0, vue_2.toDisplayString)(item.cancelledItems), 1)
                    ]),
                    _: 1
                }, 8, ["fields", "items"]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    closeable: false,
                    isOpen: successfulSubmissionModalIsOpen.value,
                    title: (0, vue_2.unref)(i18n_1.trans)('successful_modal_header', 'Customer product return Data', 'customer_product_return_list'),
                    widthClasses: "print-height print-margin-0 print-padding-0 print-width",
                    onClose: _cache[6] || (_cache[6] = ($event) => (successfulSubmissionModalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_16, [
                            (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                (0, vue_2.createElementVNode)("div", _hoisted_18, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('supplier', 'Supplier', 'customer_product_return_list')), 1),
                                (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(modalData.value.DeliveryName), 1),
                                (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(modalData.value.DeliveryZipCode), 1),
                                (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(modalData.value.DeliveryCity), 1),
                                (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(modalData.value.DeliveryStreet), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_19, [
                                (modalData.value.RequireDelivery == 1)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_20, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('shipping_mode', 'Shipping mode: ', 'customer_product_return_list')) + ": " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('delivery_shipping_mode', 'Delivery shipping mode', 'customer_product_return_list')), 1))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (modalData.value.RequireDelivery == 0)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_21, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('shipping_mode', 'Shipping mode: ', 'customer_product_return_list')) + ": " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('take_away_shipping_mode', 'Takeaway shipping mode', 'customer_product_return_list')), 1))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (0, vue_2.createElementVNode)("div", null, [
                                    (0, vue_2.createElementVNode)("div", null, "ID: " + (0, vue_2.toDisplayString)(modalData.value.AccountNum), 1),
                                    (0, vue_2.createElementVNode)("div", null, "AXAPTA ID: " + (0, vue_2.toDisplayString)(modalData.value.ProdRetId), 1),
                                    (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(modalData.value.Invoices[0].DlvName), 1),
                                    (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(modalData.value.Invoices[0].DlvZipCode), 1),
                                    (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(modalData.value.Invoices[0].DlvCity), 1),
                                    (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(modalData.value.Invoices[0].DlvStreet), 1)
                                ])
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("table", _hoisted_22, [
                            (0, vue_2.createElementVNode)("thead", _hoisted_23, [
                                (0, vue_2.createElementVNode)("tr", null, [
                                    (0, vue_2.createElementVNode)("th", _hoisted_24, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('invoice_id', 'Invoice ID', 'customer_product_return_list')), 1),
                                    (0, vue_2.createElementVNode)("th", _hoisted_25, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('product_id', 'ID', 'customer_product_return_list')), 1),
                                    (0, vue_2.createElementVNode)("th", _hoisted_26, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('name', 'Name', 'customer_product_return_list')), 1),
                                    (0, vue_2.createElementVNode)("th", _hoisted_27, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('requested_quantity', 'Requested q.', 'customer_product_return_list')), 1),
                                    (0, vue_2.createElementVNode)("th", _hoisted_28, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('accepted_quantity', 'Accepted q.', 'customer_product_return_list')), 1),
                                    (0, vue_2.createElementVNode)("th", _hoisted_29, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('acceptance_status', 'Acceptance Status', 'customer_product_return_list')), 1),
                                    (0, vue_2.createElementVNode)("th", _hoisted_30, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('sales_status', 'Sales Status', 'customer_product_return_list')), 1),
                                    (0, vue_2.createElementVNode)("th", _hoisted_31, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('sales_id', 'Sales ID', 'customer_product_return_list')), 1)
                                ])
                            ]),
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(modalData.value.Invoices, (invoice) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tbody", _hoisted_32, [
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(invoice.Lines, (item) => {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", _hoisted_33, [
                                            (0, vue_2.createElementVNode)("th", _hoisted_34, (0, vue_2.toDisplayString)(invoice.InvoiceId), 1),
                                            (0, vue_2.createElementVNode)("th", _hoisted_35, (0, vue_2.toDisplayString)(item.ItemId), 1),
                                            (0, vue_2.createElementVNode)("th", _hoisted_36, (0, vue_2.toDisplayString)(item.ItemName), 1),
                                            (0, vue_2.createElementVNode)("th", _hoisted_37, (0, vue_2.toDisplayString)(item.RequestedQty), 1),
                                            (0, vue_2.createElementVNode)("th", _hoisted_38, (0, vue_2.toDisplayString)(item.AcceptedQty), 1),
                                            (0, vue_2.createElementVNode)("th", _hoisted_39, [
                                                (item.AcceptanceStatus == 0)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_40, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('no_status', 'No status', 'customer_product_return_list')), 1))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                (item.AcceptanceStatus == 1)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_41, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('accepted', 'Accepted', 'customer_product_return_list')), 1))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                (item.AcceptanceStatus == 2)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_42, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('declined', 'Declined', 'customer_product_return_list')), 1))
                                                    : (0, vue_2.createCommentVNode)("", true)
                                            ]),
                                            (0, vue_2.createElementVNode)("th", _hoisted_43, [
                                                (item.CreditedSalesIdStatus == 1)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_44, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('open', 'Open', 'customer_product_return_list')), 1))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                (item.CreditedSalesIdStatus == 2)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_45, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('shipped', 'Shipped', 'customer_product_return_list')), 1))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                (item.CreditedSalesIdStatus == 3)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_46, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('invoiced', 'Invoiced', 'customer_product_return_list')), 1))
                                                    : (0, vue_2.createCommentVNode)("", true)
                                            ]),
                                            (0, vue_2.createElementVNode)("th", _hoisted_47, (0, vue_2.toDisplayString)(item.CreditedSalesId), 1)
                                        ]));
                                    }), 256))
                                ]));
                            }), 256))
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_48, [
                            (0, vue_2.createElementVNode)("div", _hoisted_49, [
                                (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(modalData.value.DeliveryCity) + ", " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.d)(new Date(), 'short', 'hu-HU')), 1)
                            ]),
                            _hoisted_50,
                            (0, vue_2.createElementVNode)("div", _hoisted_51, [
                                _hoisted_52,
                                (0, vue_2.createElementVNode)("div", _hoisted_53, (0, vue_2.toDisplayString)(modalData.value.DeliveryName), 1)
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_54, [
                            (0, vue_2.createElementVNode)("div", _hoisted_55, [
                                (0, vue_2.createElementVNode)("button", {
                                    type: "button",
                                    class: "!py-3 w-full lg:w-auto inline-block btn btn-rounded btn-warning",
                                    onClick: _cache[4] || (_cache[4] = ($event) => (printPage()))
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('print', "Print", 'customer_product_return_list')), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_56, [
                                (0, vue_2.createElementVNode)("button", {
                                    type: "button",
                                    class: "!py-3 w-full lg:w-auto inline-block btn btn-rounded btn-primary",
                                    onClick: _cache[5] || (_cache[5] = ($event) => (successfulSubmissionModalIsOpen.value = false))
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('close', "Close", 'customer_product_return_list')), 1)
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["isOpen", "title"])
            ]));
        };
    }
});
